import { apiFetch, appConfig } from '@ami/react/core';

export function isPasswordValid(str) {
    return str.length >= 8;
}
  
export async function changePassword(request) {
    const url = `${appConfig.isDealerApp ? 'dealer-users' : 'users'}/change`;
    return await apiFetch(url, 'POST', request);
}